import Vue from 'vue'
import OutsideClick from './OutsideClick'

Vue.directive('keyup-input', {
  bind (el, binding, vnode) {
    let vm = vnode.context
    let callback = binding.value

    el.keyupInput = function (event) {
      if (event.keyCode === 13) {
        return
      }

      return callback.call(vm, event)
    }

    el.addEventListener('keyup', el.keyupInput)
  },
  unbind (el) {
    el.removeEventListener('keyup', el.keyupInput)
  }
})

Vue.directive('focus', {
  // When the bound element is inserted into the DOM…
  inserted: function (el, binding) {
    if (binding.value) {
      // Focus the element
      el.focus()
    }
  }
})

Vue.directive('outside-click', OutsideClick)

Vue.directive('outside-element-mousedown', {
  bind: function (el, binding, vnode) {
    el.outsideElementClick = function (event) {
      if (event.offsetX > event.target.clientWidth || event.offsetY > event.target.clientHeight) {
        return
      }
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('mousedown', el.outsideElementClick)
  },
  unbind: function (el) {
    document.body.removeEventListener('mousedown', el.outsideElementClick)
  }
})

Vue.directive('outside-element-mouseup', {
  bind: function (el, binding, vnode) {
    el.outsideElementClick = function (event) {
      if (event.offsetX > event.target.clientWidth || event.offsetY > event.target.clientHeight) {
        return
      }
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('mouseup', el.outsideElementClick)
  },
  unbind: function (el) {
    document.body.removeEventListener('mouseup', el.outsideElementClick)
  }
})



// WEBPACK FOOTER //
// ./src/directives/index.js